import { RouterParams } from './routerUtility/RouterParams';

var PATH_QUERY_STRING = '?returnUrl={0}';

var RoutePath = require('../constants/routePath');
var ModuleStore = require('store/moduleStore');
var AuthenticationStore = require('store/authenticationStore');
var AppError = require('../utils/appError');

var RouterUtility = {
  routerParams: new RouterParams(),

  getAccessError: function (moduleAccessCode) {
    //checking order is important!
    if (!AuthenticationStore.isLoggedIn()){
      return new AppError(AppError.CODE_UNAUTHORIZED);
    }

    if (moduleAccessCode !== undefined){
      if (!ModuleStore.isModuleAvailable(moduleAccessCode)){
        return new AppError(AppError.CODE_ACCESS_DENIDED);
      }
    }

    if (!ModuleStore.getCurrentModule()) {
      return new AppError(AppError.CODE_NO_AVAILABLE_MODULES);
    }

    return null;
  },

  /**
   * Get "Type" parameter by route
   * @returns {*|string} value "Type" parameter
   */
  getTypeParameter: function () {
    return this.routerParams.type;
  },

  /**
   * Get "Session" parameter by route
   * @returns {*|string} value "Session" parameter
   */
  getSessionParameter: function () {
    return this.routerParams.session;
  },

  /**
   * Get "Token" parameter by route
   * @returns {*|string} value "Token" parameter
   */
  getTokenParameter: function () {
    return this.routerParams.token;
  },

  /**
   * Get "2bap External Token" parameter by route
   * @returns {*|string} value "Token" parameter
   */
  get2bapExternalTokenParameter: function () {
    return this.routerParams.external2bapToken;
  },

  /**
   * Get "Return url" parameter by route
   * @returns {*|string} value "Return url" parameter
   */
  getReturnUrlParameter: function () {
    return this.routerParams.returnUrl;
  },

  /**
   * Unauthorized redirection
   */
  redirectUnauthorized: function () {
    var queryString = this._getPathQuery();
    window.document.location.href = RoutePath.ROUTE_LOGIN + queryString;
  },

  getPathQuery: function (pathName) {
    if (pathName.substring(0, 1) == '/') {
      pathName = pathName.substring(1);
    }

    var queryString = '';
    if (pathName) {
      queryString = PATH_QUERY_STRING.format([pathName]);
    }
    return queryString;
  },

  /**
   * Get route path with module
   * @param modulePath module path
   * @param routePath route path
   * @returns {*} route path with module
   */
  getRoutePath: function (modulePath, routePath) {
    routePath = routePath || '';
    return modulePath ? ['', modulePath, routePath].join('/') : routePath;
  }

};

module.exports = RouterUtility;
